import { ComponentLoader } from '../../webana';

import { Calendar } from './components/calendar';
import { Calendar2 } from './components/calendar2';
import { BlahDrag } from './components/dragndrop';

export const components: { [key: string]: ComponentLoader } = {
  'webana:Calendar': async () => Calendar,
  'webana:Calendar2': async () => Calendar2,
  'webana:BlahDrag': async () => BlahDrag
};



// WEBPACK FOOTER //
// ./src/modules/calendar/index.ts